import React from "react";
import { useI18n } from "../contexts/I18nContext";

function CriticalAbout() {
    const { t } = useI18n();

    return (
        <section className="critical-about" aria-hidden="true">
            <div>
                <div className="critical-about-title">
                    <div>
                        <h1>
                            xsiadron<span>&nbsp;{"[Luke\u00A0Frydrych]"}</span>
                        </h1>
                    </div>
                    <div>
                        <small>
                            {t("about.rolePrefix")}
                            <ul>
                                <li className="role-dot">
                                    <span>&#9898;</span>
                                </li>
                                <li>{t("about.roleGame")}</li>
                                <li className="role-dot">
                                    <span>&#9898;</span>
                                </li>
                                <li>{t("about.roleApp")}</li>
                                <li className="role-dot">
                                    <span>&#9898;</span>
                                </li>
                                <li>{t("about.roleWeb")}</li>
                            </ul>
                            {t("about.roleSuffix")}
                        </small>
                    </div>
                    <div>
                        <div>
                            <b>{t("about.greeting")}</b> {t("about.intro")}
                            <br />
                            {t("about.introSecond")}
                            <br />
                            <br />
                            <div className="critical-build-projects-text-block">
                                {t("about.builtPrefix")}
                                <div className="critical-build-projects">
                                    <span>{t("about.tools.game").replaceAll(" ", "\u00A0")}</span>{" "}
                                    <span>{t("about.tools.android").replaceAll(" ", "\u00A0")}</span>{" "}
                                    <span>{t("about.tools.graphics2d").replaceAll(" ", "\u00A0")}</span>{" "}
                                    <span>{t("about.tools.graphics3d").replaceAll(" ", "\u00A0")}</span>{" "}
                                    <span>{t("about.tools.media").replaceAll(" ", "\u00A0")}</span>
                                    <div>&ensp;{t("about.tools.various").replaceAll(" ", "\u00A0")}&nbsp;<span>{t("about.tools.ides")}</span></div>
                                </div>
                            </div>
                        </div>
                        <br />
                    </div>
                    <div>
                        <p className="critical-programming-languages">
                            {t("about.languagesPrefix")}&ensp;
                            <span>C++</span> <span>C#</span>{" "}
                            <span>TypeScript</span>{" "}
                            <span>React</span>{" "}
                            <span>SQL</span>{" "}
                            <span>Python</span>{" "}
                            <span>Lua</span>
                            <span>Java</span>
                            &nbsp;&&nbsp;
                            <span>Kotlin</span>
                        </p>
                        <br />
                        <br />
                    </div>
                    <div>
                        <p>
                            {t("about.contact")}{" "}
                            <b>{t("about.contactLink").replaceAll(" ", "\u00A0")}</b>
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default CriticalAbout;
